module.exports = __webpack_public_path__ + "static/media/storyC_background.73520f6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/storyC/static/storyC_background.png
// module id = 359
// module chunks = 0